import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../components/mensajes";
import { Dimmer } from "../components/spinner";

import useTable from "../components/useTable";

import axios from "axios";
import { DangerButton, SuccessButton } from "../ui/buttons/Button";
import { SearchInput } from "../ui/inputs/Input";

const CatalogoPersona = (props) => {
  let op = require("../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const btnCancela = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [activo, setActivo] = useState(true);
  const [values, setValues] = useState({});
  const [itemSelect, setItemSelect] = useState(-1);
  const headCells = [
    {
      id: "cedula",
      label: "CEDULA",
      width: "10px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "apellidos",
      label: "APELLIDOS",
      width: "300px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "nombres",
      label: "NOMBRES",
      width: "300px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);
  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.cedula.includes(target.value) ||
              x.apellidos.toLowerCase().includes(target.value.toLowerCase()) ||
              x.nombres.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarPersonasTodas = () => {
    let endpoint = `${op.conexion}/api/catalogo/personas`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setActivate(false);
          var perso = [];
          for (let i = 0; i < response.data.length; i++) {
            perso.push({
              cedula: response.data[i].cedula,
              nombres: response.data[i].nombres,
              apellidos: response.data[i].apellidos,
              correoe: response.data[i].correoe,
              tlf1: response.data[i].tlf1,
              tlf2: response.data[i].tlf2,
              fnacimiento: response.data[i].fnacimiento,
              nacionalidad: response.data[i].nacionalidad,
              sexo: response.data[i].sexo,
              direccion: response.data[i].direccion,
            });
          }
          setRecords(perso);
        }
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };
  const seleccionarLista = (index) => (event) => {
    blanquear();
    props.onHideAceptaCatPer(
      values[0].cedPer,
      values[0].nomPer,
      values[0].apePer,
      values[0].correoPer,
      values[0].tlf1Per,
      values[0].tlf2Per,
      values[0].fnacPer,
      values[0].nacPer,
      values[0].sexoPer,
      values[0].direPer
    );
  };
  const blanquear = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setActivate(false);
    setRecords([]);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
  };
  const handleCloseMensa = () => {
    setMostrar(false);
  };
  const cancelar = () => {
    blanquear();
    props.onHideCancelaCatPer();
  };
  const seleccionarFila = (index) => (event) => {
    setItemSelect(index);
    setActivo(false);
    var cedPer = recordsAfterPagingAndSorting()[index].cedula;
    var nomPer = recordsAfterPagingAndSorting()[index].nombres;
    var apePer = recordsAfterPagingAndSorting()[index].apellidos;
    var correoPer = recordsAfterPagingAndSorting()[index].correoe;
    var tlf1Per = recordsAfterPagingAndSorting()[index].tlf1;
    var tlf2Per = recordsAfterPagingAndSorting()[index].tlf2;
    var fnacPer = recordsAfterPagingAndSorting()[index].fnacimiento;
    var nacPer = recordsAfterPagingAndSorting()[index].nacionalidad;
    var sexoPer = recordsAfterPagingAndSorting()[index].sexo;
    var direPer = recordsAfterPagingAndSorting()[index].direccion;
    var datos = [];
    datos.push({
      cedPer,
      nomPer,
      apePer,
      correoPer,
      tlf1Per,
      tlf2Per,
      fnacPer,
      nacPer,
      sexoPer,
      direPer,
    });
    setValues(datos);
  };
  return (
    <Modal
      {...props}
      size="lg"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.521)",
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarPersonasTodas();
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2">
        <Modal.Title className="text-light fs-4 fw-bold m-0">
          Seleccionar Personas.
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        
        <div className="col-6 m-0 mb-2 p-0">
          <SearchInput 
            onChange={handleSearch}
          />
        </div>
        <div className="col-12 p-0 m-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={item.cedula}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <td
                      style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "10px",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.cedula}
                    </td>
                    <td
                      style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "300px",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.apellidos}
                    </td>
                    <td
                      style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "300px",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.nombres}
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          disabled={activo}
          onClick={seleccionarLista()}
        >
            Aceptar
        </SuccessButton>

        <DangerButton
          ref={btnCancela}
          onClick={cancelar}
        >
            Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
          titulo={titulo}
          mensaje={msg}
          show={mostrar}
          onHide={handleCloseMensa}
        />
        <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};

export default CatalogoPersona;
